module.exports = __webpack_public_path__ + "static/media/why-giztix.c1f197fc.png";